export default "__VITE_ASSET__5iCWVCLQ__"